import * as React from 'react';
import { compose } from 'recompose';
import { injectIntl, InjectedIntlProps } from 'react-intl';

import IMPComponent from '../interfaces/IMPComponent';
import SvgIcon from '../SvgIcon';

import styled from 'styled-components';

interface ICloudLabelProps extends IMPComponent {
  children?: React.ReactNode;
}

const CloudLabelIcon = styled.div`
  display: flex;
  justify-content: center;
`;

const CloudLabelText = styled.div`
  color: ${p => p.theme.color.battleshipGrey};
  font-size: ${p => p.theme.font.size.xSmall};
  margin-top: 1rem;
  text-align: center;
`;

const CloudLabel = (props: ICloudLabelProps & InjectedIntlProps) => {
  const text = props.children ? props.children : props.intl.formatMessage({ id: 'components.CloudLabel' });

  return (
    <div>
      <CloudLabelIcon className="CloudLabel-icon">
        <SvgIcon iconName="cloud-grey" />
      </CloudLabelIcon>
      <CloudLabelText>{text}</CloudLabelText>
    </div>
  );
};

const enhance = compose<ICloudLabelProps & InjectedIntlProps, ICloudLabelProps>(
  injectIntl,
  React.memo,
);

export default enhance(CloudLabel);



// WEBPACK FOOTER //
// ./src/components/CloudLabel/index.tsx